function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(43.921569%,43.921569%,43.921569%)",
      fillOpacity: 1
    },
    d: "M 34.699219 36.800781 L 13.300781 36.800781 C 6.300781 36.800781 0.5 31.101562 0.5 24 C 0.5 16.898438 6.300781 11.199219 13.300781 11.199219 L 34.601562 11.199219 C 41.699219 11.199219 47.398438 17 47.398438 24 C 47.5 31.101562 41.699219 36.800781 34.699219 36.800781 Z M 13.300781 12.199219 C 6.800781 12.199219 1.5 17.5 1.5 24 C 1.5 30.5 6.800781 35.800781 13.300781 35.800781 L 34.601562 35.800781 C 41.101562 35.800781 46.398438 30.5 46.398438 24 C 46.398438 17.5 41.101562 12.199219 34.601562 12.199219 Z M 13.300781 12.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24 24 C 24 29.910156 19.210938 34.699219 13.300781 34.699219 C 7.390625 34.699219 2.601562 29.910156 2.601562 24 C 2.601562 18.089844 7.390625 13.300781 13.300781 13.300781 C 19.210938 13.300781 24 18.089844 24 24 Z M 24 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(43.921569%,43.921569%,43.921569%)",
      fillOpacity: 1
    },
    d: "M 13.300781 34.601562 C 7.5 34.601562 2.699219 29.800781 2.699219 24 C 2.699219 18.199219 7.5 13.398438 13.300781 13.398438 C 19.101562 13.398438 23.898438 18.199219 23.898438 24 C 23.898438 29.800781 19.199219 34.601562 13.300781 34.601562 Z M 13.300781 14.398438 C 8 14.398438 3.699219 18.699219 3.699219 24 C 3.699219 29.300781 8 33.601562 13.300781 33.601562 C 18.601562 33.601562 22.898438 29.300781 22.898438 24 C 22.898438 18.699219 18.601562 14.398438 13.300781 14.398438 Z M 13.300781 14.398438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleoff);
export default __webpack_public_path__ + "static/media/toggle off.5d3e4291fa3860195355eeadca81b2c6.svg";
export { ForwardRef as ReactComponent };